<div class="page-content">
  <h1 [attr.data-translate]="title">{{ title }}</h1>

  <ul class="movies-list">
    <li class="movies-item" *ngFor="let movie of movies; let i = index">
      <div class="movie-card">
        <a
          class="movie-portrait"
          [ngClass]="{ 'no-pointer': isNoMovieTagPresent(movie) }"
          [routerLink]="'/movie/' + movie.friendlyUrl"
        >
          <img [src]="movie.portraitPhotoUrl | img: { width: 200 }" [alt]="movie.trTitle + ' portrait'" />
        </a>
        <div class="movie-data">
          <h2 class="movie-title">
            <a [routerLink]="'/movie/' + movie.friendlyUrl">
              {{ movie.trTitle }}
            </a>
          </h2>
          <div class="movie-description">
            <div [innerHTML]="movie.description"></div>
          </div>
          <h3 *ngIf="moviesCast && moviesCast[i].length > 0">Cast</h3>
          <div class="movie-cast" *ngIf="moviesCast && moviesCast[i].length > 0">{{ moviesCast[i] }}</div>
        </div>
      </div>
    </li>
  </ul>
</div>
